import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import BoxRendererType from '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType';
import { createJBrowseTheme } from '@jbrowse/core/ui';
import { bpSpanPx, iterMap, measureText } from '@jbrowse/core/util';
import { renderToAbstractCanvas } from '@jbrowse/core/util/offscreenCanvasUtils';
import { getAdapter } from '@jbrowse/core/data_adapters/dataAdapterCache';
import { readConfObject } from '@jbrowse/core/configuration';
// locals
import { parseCigar, getModificationPositions, getNextRefPos } from '../MismatchParser';
import { sortFeature } from './sortUtil';
import { getTagAlt, orientationTypes, fetchSequence as _fetchSequence, shouldFetchReferenceSequence } from '../util';
import { PileupLayoutSession } from './PileupLayoutSession';
function fillRect(ctx, l, t, w, h, cw, color) {
  if (l + w < 0 || l > cw) {
    return;
  } else {
    if (color) {
      ctx.fillStyle = color;
    }
    ctx.fillRect(l, t, w, h);
  }
}
function getColorBaseMap(theme) {
  var bases = theme.palette.bases;
  return {
    A: bases.A.main,
    C: bases.C.main,
    G: bases.G.main,
    T: bases.T.main,
    deletion: '#808080' // gray
  };
}

function getContrastBaseMap(theme) {
  var map = getColorBaseMap(theme);
  return Object.fromEntries(Object.entries(map).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return [k, theme.palette.getContrastText(v)];
  }));
}
var alignmentColoring = {
  color_fwd_strand_not_proper: '#ECC8C8',
  color_rev_strand_not_proper: '#BEBED8',
  color_fwd_strand: '#EC8B8B',
  color_rev_strand: '#8F8FD8',
  color_fwd_missing_mate: '#D11919',
  color_rev_missing_mate: '#1919D1',
  color_fwd_diff_chr: '#000',
  color_rev_diff_chr: '#969696',
  color_pair_lr: '#c8c8c8',
  color_pair_rr: 'navy',
  color_pair_rl: 'teal',
  color_pair_ll: 'green',
  color_nostrand: '#c8c8c8',
  color_interchrom: 'orange',
  color_longinsert: 'red',
  color_shortinsert: 'pink'
};
function shouldDrawSNPsMuted(type) {
  return ['methylation', 'modifications'].includes(type || '');
}
function shouldDrawIndels(type) {
  return true;
}
var PileupRenderer = /*#__PURE__*/function (_BoxRendererType) {
  _inherits(PileupRenderer, _BoxRendererType);
  function PileupRenderer() {
    var _this;
    _classCallCheck(this, PileupRenderer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(PileupRenderer).apply(this, arguments));
    _this.supportsSVG = true;
    return _this;
  }
  // get width and height of chars the height is an approximation: width
  // letter M is approximately the height
  _createClass(PileupRenderer, [{
    key: "getCharWidthHeight",
    value: function getCharWidthHeight() {
      var charWidth = measureText('A');
      var charHeight = measureText('M') - 2;
      return {
        charWidth: charWidth,
        charHeight: charHeight
      };
    }
  }, {
    key: "layoutFeature",
    value: function layoutFeature(_ref3) {
      var feature = _ref3.feature,
        layout = _ref3.layout,
        bpPerPx = _ref3.bpPerPx,
        region = _ref3.region,
        showSoftClip = _ref3.showSoftClip,
        heightPx = _ref3.heightPx,
        displayMode = _ref3.displayMode;
      var expansionBefore = 0;
      var expansionAfter = 0;
      // Expand the start and end of feature when softclipping enabled
      if (showSoftClip) {
        var mismatches = feature.get('mismatches');
        var seq = feature.get('seq');
        if (seq && mismatches) {
          for (var i = 0; i < mismatches.length; i += 1) {
            var _mismatches$i = mismatches[i],
              type = _mismatches$i.type,
              start = _mismatches$i.start,
              _mismatches$i$cliplen = _mismatches$i.cliplen,
              cliplen = _mismatches$i$cliplen === void 0 ? 0 : _mismatches$i$cliplen;
            if (type === 'softclip') {
              start === 0 ? expansionBefore = cliplen : expansionAfter = cliplen;
            }
          }
        }
      }
      var _bpSpanPx = bpSpanPx(feature.get('start') - expansionBefore, feature.get('end') + expansionAfter, region, bpPerPx),
        _bpSpanPx2 = _slicedToArray(_bpSpanPx, 2),
        leftPx = _bpSpanPx2[0],
        rightPx = _bpSpanPx2[1];
      if (displayMode === 'compact') {
        heightPx /= 3;
      }
      if (feature.get('refName') !== region.refName) {
        throw new Error("feature ".concat(feature.id(), " is not on the current region's reference sequence ").concat(region.refName));
      }
      var topPx = layout.addRect(feature.id(), feature.get('start') - expansionBefore, feature.get('end') + expansionAfter, heightPx, feature);
      if (topPx === null) {
        return null;
      }
      return {
        feature: feature,
        leftPx: leftPx,
        rightPx: rightPx,
        topPx: displayMode === 'collapse' ? 0 : topPx,
        heightPx: heightPx
      };
    } // expands region for clipping to use. possible improvement: use average read
    // size to set the heuristic maxClippingSize expansion (e.g. short reads
    // don't have to expand a softclipping size a lot, but long reads might)
  }, {
    key: "getExpandedRegion",
    value: function getExpandedRegion(region, renderArgs) {
      var config = renderArgs.config,
        showSoftClip = renderArgs.showSoftClip;
      var maxClippingSize = readConfObject(config, 'maxClippingSize');
      var start = region.start,
        end = region.end;
      var bpExpansion = showSoftClip ? Math.round(maxClippingSize) : 0;
      return _objectSpread({}, region, {
        start: Math.floor(Math.max(start - bpExpansion, 0)),
        end: Math.ceil(end + bpExpansion)
      });
    }
  }, {
    key: "colorByOrientation",
    value: function colorByOrientation(feature, config) {
      return alignmentColoring[this.getOrientation(feature, config) || 'color_nostrand'];
    }
  }, {
    key: "getOrientation",
    value: function getOrientation(feature, config) {
      var orientationType = readConfObject(config, 'orientationType');
      var type = orientationTypes[orientationType];
      var orientation = type[feature.get('pair_orientation')];
      var map = {
        LR: 'color_pair_lr',
        RR: 'color_pair_rr',
        RL: 'color_pair_rl',
        LL: 'color_pair_ll'
      };
      return map[orientation];
    }
  }, {
    key: "colorByInsertSize",
    value: function colorByInsertSize(feature, _config) {
      return feature.get('is_paired') && feature.get('refName') !== feature.get('next_ref') ? '#555' : "hsl(".concat(Math.abs(feature.get('template_length')) / 10, ",50%,50%)");
    }
  }, {
    key: "colorByStranded",
    value: function colorByStranded(feature, _config) {
      var flags = feature.get('flags');
      var strand = feature.get('strand');
      // is paired
      if (flags & 1) {
        var revflag = flags & 64;
        var flipper = revflag ? -1 : 1;
        // proper pairing
        if (flags & 2) {
          return strand * flipper === 1 ? 'color_rev_strand' : 'color_fwd_strand';
        }
        if (feature.get('multi_segment_next_segment_unmapped')) {
          return strand * flipper === 1 ? 'color_rev_missing_mate' : 'color_fwd_missing_mate';
        }
        if (feature.get('refName') === feature.get('next_refName')) {
          return strand * flipper === 1 ? 'color_rev_strand_not_proper' : 'color_fwd_strand_not_proper';
        }
        // should only leave aberrant chr
        return strand === 1 ? 'color_fwd_diff_chr' : 'color_rev_diff_chr';
      }
      return strand === 1 ? 'color_fwd_strand' : 'color_rev_strand';
    }
  }, {
    key: "colorByPerBaseLettering",
    value: function colorByPerBaseLettering(_ref4) {
      var ctx = _ref4.ctx,
        feat = _ref4.feat,
        region = _ref4.region,
        bpPerPx = _ref4.bpPerPx,
        colorForBase = _ref4.colorForBase,
        contrastForBase = _ref4.contrastForBase,
        charWidth = _ref4.charWidth,
        charHeight = _ref4.charHeight,
        canvasWidth = _ref4.canvasWidth;
      var heightLim = charHeight - 2;
      var feature = feat.feature,
        topPx = feat.topPx,
        heightPx = feat.heightPx;
      var seq = feature.get('seq');
      var cigarOps = parseCigar(feature.get('CIGAR'));
      var w = 1 / bpPerPx;
      var start = feature.get('start');
      var soffset = 0; // sequence offset
      var roffset = 0; // reference offset
      for (var i = 0; i < cigarOps.length; i += 2) {
        var len = +cigarOps[i];
        var op = cigarOps[i + 1];
        if (op === 'S' || op === 'I') {
          soffset += len;
        } else if (op === 'D' || op === 'N') {
          roffset += len;
        } else if (op === 'M' || op === 'X' || op === '=') {
          for (var m = 0; m < len; m++) {
            var letter = seq[soffset + m];
            var r = start + roffset + m;
            var _bpSpanPx3 = bpSpanPx(r, r + 1, region, bpPerPx),
              _bpSpanPx4 = _slicedToArray(_bpSpanPx3, 1),
              leftPx = _bpSpanPx4[0];
            fillRect(ctx, leftPx, topPx, w + 0.5, heightPx, canvasWidth, colorForBase[letter]);
            if (w >= charWidth && heightPx >= heightLim) {
              // normal SNP coloring
              ctx.fillStyle = contrastForBase[letter];
              ctx.fillText(letter, leftPx + (w - charWidth) / 2 + 1, topPx + heightPx);
            }
          }
          soffset += len;
          roffset += len;
        }
      }
    }
  }, {
    key: "colorByPerBaseQuality",
    value: function colorByPerBaseQuality(_ref5) {
      var ctx = _ref5.ctx,
        feat = _ref5.feat,
        region = _ref5.region,
        bpPerPx = _ref5.bpPerPx,
        canvasWidth = _ref5.canvasWidth;
      var feature = feat.feature,
        topPx = feat.topPx,
        heightPx = feat.heightPx;
      var qual = feature.get('qual') || '';
      var scores = qual.split(' ').map(function (val) {
        return +val;
      });
      var cigarOps = parseCigar(feature.get('CIGAR'));
      var width = 1 / bpPerPx;
      var start = feature.get('start');
      var soffset = 0; // sequence offset
      var roffset = 0; // reference offset
      for (var i = 0; i < cigarOps.length; i += 2) {
        var len = +cigarOps[i];
        var op = cigarOps[i + 1];
        if (op === 'S' || op === 'I') {
          soffset += len;
        } else if (op === 'D' || op === 'N') {
          roffset += len;
        } else if (op === 'M' || op === 'X' || op === '=') {
          for (var m = 0; m < len; m++) {
            var score = scores[soffset + m];
            var _bpSpanPx5 = bpSpanPx(start + roffset + m, start + roffset + m + 1, region, bpPerPx),
              _bpSpanPx6 = _slicedToArray(_bpSpanPx5, 1),
              leftPx = _bpSpanPx6[0];
            fillRect(ctx, leftPx, topPx, width + 0.5, heightPx, canvasWidth, "hsl(".concat(score === 255 ? 150 : score * 1.5, ",55%,50%)"));
          }
          soffset += len;
          roffset += len;
        }
      }
    } // ML stores probabilities as array of numerics and MP is scaled phred scores
    // https://github.com/samtools/hts-specs/pull/418/files#diff-e765c6479316309f56b636f88189cdde8c40b854c7bdcce9ee7fe87a4e76febcR596
    //
    // if we have ML or Ml, it is an 8bit probability, divide by 255
    //
    // if we have MP or Mp it is phred scaled ASCII, which can go up to 90 but
    // has very high likelihood basecalls at that point, we really only care
    // about low qual calls <20 approx
    //
  }, {
    key: "colorByModifications",
    value: function colorByModifications(_ref6) {
      var ctx = _ref6.ctx,
        feat = _ref6.feat,
        region = _ref6.region,
        bpPerPx = _ref6.bpPerPx,
        renderArgs = _ref6.renderArgs,
        canvasWidth = _ref6.canvasWidth;
      var feature = feat.feature,
        topPx = feat.topPx,
        heightPx = feat.heightPx;
      var Color = renderArgs.Color,
        _renderArgs$modificat = renderArgs.modificationTagMap,
        modificationTagMap = _renderArgs$modificat === void 0 ? {} : _renderArgs$modificat;
      var mm = getTagAlt(feature, 'MM', 'Mm') || '';
      var ml = getTagAlt(feature, 'ML', 'Ml') || [];
      var probabilities = ml ? (typeof ml === 'string' ? ml.split(',').map(function (e) {
        return +e;
      }) : ml).map(function (e) {
        return e / 255;
      }) : getTagAlt(feature, 'MP', 'Mp').split('').map(function (s) {
        return s.charCodeAt(0) - 33;
      }).map(function (elt) {
        return Math.min(1, elt / 50);
      });
      var cigar = feature.get('CIGAR');
      var start = feature.get('start');
      var seq = feature.get('seq');
      var strand = feature.get('strand');
      var cigarOps = parseCigar(cigar);
      var modifications = getModificationPositions(mm, seq, strand);
      // probIndex applies across multiple modifications e.g.
      var probIndex = 0;
      for (var i = 0; i < modifications.length; i++) {
        var _modifications$i = modifications[i],
          type = _modifications$i.type,
          positions = _modifications$i.positions;
        var col = modificationTagMap[type] || 'black';
        // @ts-ignore
        var base = Color(col);
        var _iterator = _createForOfIteratorHelper(getNextRefPos(cigarOps, positions)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var readPos = _step.value;
            var r = start + readPos;
            var _bpSpanPx7 = bpSpanPx(r, r + 1, region, bpPerPx),
              _bpSpanPx8 = _slicedToArray(_bpSpanPx7, 2),
              leftPx = _bpSpanPx8[0],
              rightPx = _bpSpanPx8[1]; // give it a little boost of 0.1 to not make them fully
            // invisible to avoid confusion
            var prob = probabilities[probIndex];
            fillRect(ctx, leftPx, topPx, rightPx - leftPx + 0.5, heightPx, canvasWidth, prob && prob !== 1 ? base.alpha(prob + 0.1).hsl().string() : col);
            probIndex++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } // Color by methylation is slightly modified version of color by
    // modifications that focuses on CpG sites, with non-methylated CpG colored
    // blue
  }, {
    key: "colorByMethylation",
    value: function colorByMethylation(_ref7) {
      var ctx = _ref7.ctx,
        feat = _ref7.feat,
        region = _ref7.region,
        bpPerPx = _ref7.bpPerPx,
        renderArgs = _ref7.renderArgs,
        canvasWidth = _ref7.canvasWidth;
      var regionSequence = renderArgs.regionSequence;
      var feature = feat.feature,
        topPx = feat.topPx,
        heightPx = feat.heightPx;
      var mm = getTagAlt(feature, 'MM', 'Mm') || '';
      if (!regionSequence) {
        throw new Error('region sequence required for methylation');
      }
      var cigar = feature.get('CIGAR');
      var fstart = feature.get('start');
      var fend = feature.get('end');
      var seq = feature.get('seq');
      var strand = feature.get('strand');
      var cigarOps = parseCigar(cigar);
      var methBins = new Array(region.end - region.start).fill(0);
      var modifications = getModificationPositions(mm, seq, strand);
      for (var i = 0; i < modifications.length; i++) {
        var _modifications$i2 = modifications[i],
          type = _modifications$i2.type,
          positions = _modifications$i2.positions;
        if (type === 'm' && positions) {
          var _iterator2 = _createForOfIteratorHelper(getNextRefPos(cigarOps, positions)),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var pos = _step2.value;
              var epos = pos + fstart - region.start;
              if (epos >= 0 && epos < methBins.length) {
                methBins[epos] = 1;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
      for (var j = fstart; j < fend; j++) {
        var _i = j - region.start;
        if (_i >= 0 && _i < methBins.length) {
          var l1 = regionSequence[_i].toLowerCase();
          var l2 = regionSequence[_i + 1].toLowerCase();
          // if we are zoomed out, display just a block over the cpg
          if (bpPerPx > 2) {
            if (l1 === 'c' && l2 === 'g') {
              var s = region.start + _i;
              var _bpSpanPx9 = bpSpanPx(s, s + 2, region, bpPerPx),
                _bpSpanPx10 = _slicedToArray(_bpSpanPx9, 2),
                leftPx = _bpSpanPx10[0],
                rightPx = _bpSpanPx10[1];
              fillRect(ctx, leftPx, topPx, rightPx - leftPx + 0.5, heightPx, canvasWidth, methBins[_i] || methBins[_i + 1] ? 'red' : 'blue');
            }
          }
          // if we are zoomed in, color the c inside the cpg
          else {
            // color
            if (l1 === 'c' && l2 === 'g') {
              var _s = region.start + _i;
              var _bpSpanPx11 = bpSpanPx(_s, _s + 1, region, bpPerPx),
                _bpSpanPx12 = _slicedToArray(_bpSpanPx11, 2),
                _leftPx = _bpSpanPx12[0],
                _rightPx = _bpSpanPx12[1];
              fillRect(ctx, _leftPx, topPx, _rightPx - _leftPx + 0.5, heightPx, canvasWidth, methBins[_i] ? 'red' : 'blue');
              var _bpSpanPx13 = bpSpanPx(_s + 1, _s + 2, region, bpPerPx),
                _bpSpanPx14 = _slicedToArray(_bpSpanPx13, 2),
                leftPx2 = _bpSpanPx14[0],
                rightPx2 = _bpSpanPx14[1];
              fillRect(ctx, leftPx2, topPx, rightPx2 - leftPx2 + 0.5, heightPx, canvasWidth, methBins[_i + 1] ? 'red' : 'blue');
            }
          }
        }
      }
    }
  }, {
    key: "drawRect",
    value: function drawRect(ctx, feat, props) {
      var regions = props.regions,
        bpPerPx = props.bpPerPx;
      var heightPx = feat.heightPx,
        topPx = feat.topPx,
        feature = feat.feature;
      var _regions = _slicedToArray(regions, 1),
        region = _regions[0];
      var _bpSpanPx15 = bpSpanPx(feature.get('start'), feature.get('end'), region, bpPerPx),
        _bpSpanPx16 = _slicedToArray(_bpSpanPx15, 2),
        leftPx = _bpSpanPx16[0],
        rightPx = _bpSpanPx16[1];
      var flip = region.reversed ? -1 : 1;
      var strand = feature.get('strand') * flip;
      if (bpPerPx < 10) {
        if (strand === -1) {
          ctx.beginPath();
          ctx.moveTo(leftPx - 5, topPx + heightPx / 2);
          ctx.lineTo(leftPx, topPx + heightPx);
          ctx.lineTo(rightPx, topPx + heightPx);
          ctx.lineTo(rightPx, topPx);
          ctx.lineTo(leftPx, topPx);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.beginPath();
          ctx.moveTo(leftPx, topPx);
          ctx.lineTo(leftPx, topPx + heightPx);
          ctx.lineTo(rightPx, topPx + heightPx);
          ctx.lineTo(rightPx + 5, topPx + heightPx / 2);
          ctx.lineTo(rightPx, topPx);
          ctx.closePath();
          ctx.fill();
        }
      } else {
        ctx.fillRect(leftPx, topPx, rightPx - leftPx, heightPx);
      }
    }
  }, {
    key: "drawAlignmentRect",
    value: function drawAlignmentRect(_ref8) {
      var ctx = _ref8.ctx,
        feat = _ref8.feat,
        renderArgs = _ref8.renderArgs,
        colorForBase = _ref8.colorForBase,
        contrastForBase = _ref8.contrastForBase,
        charWidth = _ref8.charWidth,
        charHeight = _ref8.charHeight,
        defaultColor = _ref8.defaultColor,
        canvasWidth = _ref8.canvasWidth;
      var config = renderArgs.config,
        bpPerPx = renderArgs.bpPerPx,
        regions = renderArgs.regions,
        colorBy = renderArgs.colorBy,
        _renderArgs$colorTagM = renderArgs.colorTagMap,
        colorTagMap = _renderArgs$colorTagM === void 0 ? {} : _renderArgs$colorTagM;
      var _ref9 = colorBy || {},
        _ref9$tag = _ref9.tag,
        tag = _ref9$tag === void 0 ? '' : _ref9$tag,
        _ref9$type = _ref9.type,
        colorType = _ref9$type === void 0 ? '' : _ref9$type;
      var feature = feat.feature;
      var region = regions[0];
      // first pass for simple color changes that change the color of the
      // alignment
      switch (colorType) {
        case 'insertSize':
          ctx.fillStyle = this.colorByInsertSize(feature, config);
          break;
        case 'strand':
          ctx.fillStyle = feature.get('strand') === -1 ? '#8F8FD8' : '#EC8B8B';
          break;
        case 'mappingQuality':
          ctx.fillStyle = "hsl(".concat(feature.get('mq'), ",50%,50%)");
          break;
        case 'pairOrientation':
          ctx.fillStyle = this.colorByOrientation(feature, config);
          break;
        case 'stranded':
          ctx.fillStyle = alignmentColoring[this.colorByStranded(feature, config)];
          break;
        case 'xs':
        case 'tag':
          {
            var tags = feature.get('tags');
            var val = tags ? tags[tag] : feature.get(tag);
            // special for for XS/TS tag
            if (tag === 'XS' || tag === 'TS') {
              var map = {
                '-': 'color_rev_strand',
                '+': 'color_fwd_strand'
              };
              ctx.fillStyle = alignmentColoring[map[val] || 'color_nostrand'];
            }
            // lower case 'ts' from minimap2 is flipped from xs
            if (tag === 'ts') {
              var _map = {
                '-': feature.get('strand') === -1 ? 'color_fwd_strand' : 'color_rev_strand',
                '+': feature.get('strand') === -1 ? 'color_rev_strand' : 'color_fwd_strand'
              };
              ctx.fillStyle = alignmentColoring[_map[val] || 'color_nostrand'];
            }
            // tag is not one of the autofilled tags, has color-value pairs from
            // fetchValues
            else {
              var foundValue = colorTagMap[val];
              ctx.fillStyle = foundValue || alignmentColoring['color_nostrand'];
            }
            break;
          }
        case 'insertSizeAndPairOrientation':
          break;
        case 'modifications':
        case 'methylation':
          // this coloring is similar to igv.js, and is helpful to color negative
          // strand reads differently because their c-g will be flipped (e.g. g-c
          // read right to left)
          if (feature.get('flags') & 16) {
            ctx.fillStyle = '#c8dcc8';
          } else {
            ctx.fillStyle = '#c8c8c8';
          }
          break;
        case 'normal':
        default:
          if (defaultColor) {
            // avoid a readConfObject call here
            ctx.fillStyle = '#c8c8c8';
          } else {
            ctx.fillStyle = readConfObject(config, 'color', {
              feature: feature
            });
          }
          break;
      }
      this.drawRect(ctx, feat, renderArgs);
      // second pass for color types that render per-base things that go over the
      // existing drawing
      switch (colorType) {
        case 'perBaseQuality':
          this.colorByPerBaseQuality({
            ctx: ctx,
            feat: feat,
            region: region,
            bpPerPx: bpPerPx,
            canvasWidth: canvasWidth
          });
          break;
        case 'perBaseLettering':
          this.colorByPerBaseLettering({
            ctx: ctx,
            feat: feat,
            region: region,
            bpPerPx: bpPerPx,
            colorForBase: colorForBase,
            contrastForBase: contrastForBase,
            charWidth: charWidth,
            charHeight: charHeight,
            canvasWidth: canvasWidth
          });
          break;
        case 'modifications':
          this.colorByModifications({
            ctx: ctx,
            feat: feat,
            region: region,
            bpPerPx: bpPerPx,
            renderArgs: renderArgs,
            canvasWidth: canvasWidth
          });
          break;
        case 'methylation':
          this.colorByMethylation({
            ctx: ctx,
            feat: feat,
            region: region,
            bpPerPx: bpPerPx,
            renderArgs: renderArgs,
            canvasWidth: canvasWidth
          });
          break;
      }
    }
  }, {
    key: "drawMismatches",
    value: function drawMismatches(_ref10) {
      var ctx = _ref10.ctx,
        feat = _ref10.feat,
        renderArgs = _ref10.renderArgs,
        minSubfeatureWidth = _ref10.minSubfeatureWidth,
        largeInsertionIndicatorScale = _ref10.largeInsertionIndicatorScale,
        mismatchAlpha = _ref10.mismatchAlpha,
        charWidth = _ref10.charWidth,
        charHeight = _ref10.charHeight,
        colorForBase = _ref10.colorForBase,
        contrastForBase = _ref10.contrastForBase,
        canvasWidth = _ref10.canvasWidth,
        drawSNPsMuted = _ref10.drawSNPsMuted,
        _ref10$drawIndels = _ref10.drawIndels,
        drawIndels = _ref10$drawIndels === void 0 ? true : _ref10$drawIndels;
      var Color = renderArgs.Color,
        bpPerPx = renderArgs.bpPerPx,
        regions = renderArgs.regions;
      var heightPx = feat.heightPx,
        topPx = feat.topPx,
        feature = feat.feature;
      var _regions2 = _slicedToArray(regions, 1),
        region = _regions2[0];
      var start = feature.get('start');
      var pxPerBp = Math.min(1 / bpPerPx, 2);
      var w = Math.max(minSubfeatureWidth, pxPerBp);
      var mismatches = feature.get('mismatches');
      var heightLim = charHeight - 2;
      // extraHorizontallyFlippedOffset is used to draw interbase items, which
      // are located to the left when forward and right when reversed
      var extraHorizontallyFlippedOffset = region.reversed ? 1 / bpPerPx + 1 : -1;
      if (!mismatches) {
        return;
      }
      // two pass rendering: first pass, draw all the mismatches except wide
      // insertion markers
      for (var i = 0; i < mismatches.length; i += 1) {
        var mismatch = mismatches[i];
        var mstart = start + mismatch.start;
        var mlen = mismatch.length;
        var mbase = mismatch.base;
        var _bpSpanPx17 = bpSpanPx(mstart, mstart + mlen, region, bpPerPx),
          _bpSpanPx18 = _slicedToArray(_bpSpanPx17, 2),
          leftPx = _bpSpanPx18[0],
          rightPx = _bpSpanPx18[1];
        var widthPx = Math.max(minSubfeatureWidth, Math.abs(leftPx - rightPx));
        if (mismatch.type === 'mismatch') {
          if (!drawSNPsMuted) {
            var baseColor = colorForBase[mismatch.base] || '#888';
            fillRect(ctx, leftPx, topPx, widthPx, heightPx, canvasWidth, !mismatchAlpha ? baseColor : mismatch.qual !== undefined ?
            // @ts-ignore
            Color(baseColor).alpha(Math.min(1, mismatch.qual / 50)).hsl().string() : baseColor);
          }
          if (widthPx >= charWidth && heightPx >= heightLim) {
            // normal SNP coloring
            var contrastColor = drawSNPsMuted ? 'black' : contrastForBase[mismatch.base] || 'black';
            ctx.fillStyle = !mismatchAlpha ? contrastColor : mismatch.qual !== undefined ?
            // @ts-ignore
            Color(contrastColor).alpha(Math.min(1, mismatch.qual / 50)).hsl().string() : contrastColor;
            ctx.fillText(mbase, leftPx + (widthPx - charWidth) / 2 + 1, topPx + heightPx);
          }
        } else if (mismatch.type === 'deletion' && drawIndels) {
          fillRect(ctx, leftPx, topPx, Math.abs(leftPx - rightPx), heightPx, canvasWidth, colorForBase.deletion);
          var txt = "".concat(mismatch.length);
          var rwidth = measureText(txt, 10);
          if (widthPx >= rwidth && heightPx >= heightLim) {
            ctx.fillStyle = contrastForBase.deletion;
            ctx.fillText(txt, (leftPx + rightPx) / 2 - rwidth / 2, topPx + heightPx);
          }
        } else if (mismatch.type === 'insertion' && drawIndels) {
          ctx.fillStyle = 'purple';
          var pos = leftPx + extraHorizontallyFlippedOffset;
          var len = +mismatch.base || mismatch.length;
          var insW = Math.max(0, Math.min(1.2, 1 / bpPerPx));
          if (len < 10) {
            fillRect(ctx, pos, topPx, insW, heightPx, canvasWidth, 'purple');
            if (1 / bpPerPx >= charWidth && heightPx >= heightLim) {
              fillRect(ctx, pos - insW, topPx, insW * 3, 1, canvasWidth);
              fillRect(ctx, pos - insW, topPx + heightPx - 1, insW * 3, 1, canvasWidth);
              ctx.fillText("(".concat(mismatch.base, ")"), pos + 3, topPx + heightPx);
            }
          }
        } else if (mismatch.type === 'hardclip' || mismatch.type === 'softclip') {
          var _pos = leftPx + extraHorizontallyFlippedOffset;
          fillRect(ctx, _pos, topPx, w, heightPx, canvasWidth, mismatch.type === 'hardclip' ? 'red' : 'blue');
          if (1 / bpPerPx >= charWidth && heightPx >= heightLim) {
            fillRect(ctx, _pos - w, topPx, w * 3, 1, canvasWidth);
            fillRect(ctx, _pos - w, topPx + heightPx - 1, w * 3, 1, canvasWidth);
            ctx.fillText("(".concat(mismatch.base, ")"), _pos + 3, topPx + heightPx);
          }
        } else if (mismatch.type === 'skip') {
          // fix to avoid bad rendering note that this was also related to chrome
          // bug https://bugs.chromium.org/p/chromium/issues/detail?id=1131528
          // also affected firefox ref #1236 #2750
          if (leftPx + widthPx > 0) {
            // make small exons more visible when zoomed far out
            var adjustPx = widthPx - (bpPerPx > 10 ? 1.5 : 0);
            ctx.clearRect(leftPx, topPx, adjustPx, heightPx);
            fillRect(ctx, Math.max(0, leftPx), topPx + heightPx / 2 - 1, adjustPx + (leftPx < 0 ? leftPx : 0), 2, canvasWidth, '#333');
          }
        }
      }
      // second pass, draw wide insertion markers on top
      if (drawIndels) {
        for (var _i2 = 0; _i2 < mismatches.length; _i2 += 1) {
          var _mismatch = mismatches[_i2];
          var _mstart = start + _mismatch.start;
          var _mlen = _mismatch.length;
          var _bpSpanPx19 = bpSpanPx(_mstart, _mstart + _mlen, region, bpPerPx),
            _bpSpanPx20 = _slicedToArray(_bpSpanPx19, 1),
            _leftPx2 = _bpSpanPx20[0];
          var _len = +_mismatch.base || _mismatch.length;
          var _txt = "".concat(_len);
          if (_mismatch.type === 'insertion' && _len >= 10) {
            if (bpPerPx > largeInsertionIndicatorScale) {
              fillRect(ctx, _leftPx2 - 1, topPx, 2, heightPx, canvasWidth, 'purple');
            } else if (heightPx > charHeight) {
              var _rwidth = measureText(_txt);
              var padding = 5;
              fillRect(ctx, _leftPx2 - _rwidth / 2 - padding, topPx, _rwidth + 2 * padding, heightPx, canvasWidth, 'purple');
              ctx.fillStyle = 'white';
              ctx.fillText(_txt, _leftPx2 - _rwidth / 2, topPx + heightPx);
            } else {
              var _padding = 2;
              fillRect(ctx, _leftPx2 - _padding, topPx, 2 * _padding, heightPx, canvasWidth, 'purple');
            }
          }
        }
      }
    }
  }, {
    key: "drawSoftClipping",
    value: function drawSoftClipping(_ref11) {
      var ctx = _ref11.ctx,
        feat = _ref11.feat,
        renderArgs = _ref11.renderArgs,
        config = _ref11.config,
        theme = _ref11.theme,
        canvasWidth = _ref11.canvasWidth;
      var feature = feat.feature,
        topPx = feat.topPx,
        heightPx = feat.heightPx;
      var regions = renderArgs.regions,
        bpPerPx = renderArgs.bpPerPx;
      var _regions3 = _slicedToArray(regions, 1),
        region = _regions3[0];
      var minFeatWidth = readConfObject(config, 'minSubfeatureWidth');
      var mismatches = feature.get('mismatches');
      var seq = feature.get('seq');
      var _this$getCharWidthHei = this.getCharWidthHeight(),
        charWidth = _this$getCharWidthHei.charWidth,
        charHeight = _this$getCharWidthHei.charHeight;
      var bases = theme.palette.bases;
      var colorForBase = {
        A: bases.A.main,
        C: bases.C.main,
        G: bases.G.main,
        T: bases.T.main,
        deletion: '#808080' // gray
      };
      // Display all bases softclipped off in lightened colors
      if (!(seq && mismatches)) {
        return;
      }
      mismatches.filter(function (mismatch) {
        return mismatch.type === 'softclip';
      }).forEach(function (mismatch) {
        var len = mismatch.cliplen || 0;
        var s = feature.get('start');
        var start = mismatch.start === 0 ? s - len : s + mismatch.start;
        for (var k = 0; k < len; k += 1) {
          var base = seq.charAt(k + mismatch.start);
          // If softclip length+start is longer than sequence, no need to
          // continue showing base
          if (!base) {
            return;
          }
          var _bpSpanPx21 = bpSpanPx(start + k, start + k + 1, region, bpPerPx),
            _bpSpanPx22 = _slicedToArray(_bpSpanPx21, 2),
            leftPx = _bpSpanPx22[0],
            rightPx = _bpSpanPx22[1];
          var widthPx = Math.max(minFeatWidth, rightPx - leftPx);
          // Black accounts for IUPAC ambiguity code bases such as N that
          // show in soft clipping
          var baseColor = colorForBase[base] || '#000000';
          ctx.fillStyle = baseColor;
          fillRect(ctx, leftPx, topPx, widthPx, heightPx, canvasWidth);
          if (widthPx >= charWidth && heightPx >= charHeight - 5) {
            ctx.fillStyle = theme.palette.getContrastText(baseColor);
            ctx.fillText(base, leftPx + (widthPx - charWidth) / 2 + 1, topPx + heightPx);
          }
        }
      });
    }
  }, {
    key: "makeImageData",
    value: function makeImageData(_ref12) {
      var ctx = _ref12.ctx,
        layoutRecords = _ref12.layoutRecords,
        canvasWidth = _ref12.canvasWidth,
        renderArgs = _ref12.renderArgs;
      var layout = renderArgs.layout,
        config = renderArgs.config,
        showSoftClip = renderArgs.showSoftClip,
        colorBy = renderArgs.colorBy,
        configTheme = renderArgs.theme;
      var mismatchAlpha = readConfObject(config, 'mismatchAlpha');
      var minSubfeatureWidth = readConfObject(config, 'minSubfeatureWidth');
      var largeInsertionIndicatorScale = readConfObject(config, 'largeInsertionIndicatorScale');
      var defaultColor = readConfObject(config, 'color') === '#f0f';
      var theme = createJBrowseTheme(configTheme);
      var colorForBase = getColorBaseMap(theme);
      var contrastForBase = getContrastBaseMap(theme);
      if (!layout) {
        throw new Error("layout required");
      }
      if (!layout.addRect) {
        throw new Error('invalid layout object');
      }
      ctx.font = 'bold 10px Courier New,monospace';
      var _this$getCharWidthHei2 = this.getCharWidthHeight(),
        charWidth = _this$getCharWidthHei2.charWidth,
        charHeight = _this$getCharWidthHei2.charHeight;
      var drawSNPsMuted = shouldDrawSNPsMuted(colorBy === null || colorBy === void 0 ? void 0 : colorBy.type);
      var drawIndels = shouldDrawIndels(colorBy === null || colorBy === void 0 ? void 0 : colorBy.type);
      for (var i = 0; i < layoutRecords.length; i++) {
        var feat = layoutRecords[i];
        if (feat === null) {
          continue;
        }
        this.drawAlignmentRect({
          ctx: ctx,
          feat: feat,
          renderArgs: renderArgs,
          defaultColor: defaultColor,
          colorForBase: colorForBase,
          contrastForBase: contrastForBase,
          charWidth: charWidth,
          charHeight: charHeight,
          canvasWidth: canvasWidth
        });
        this.drawMismatches({
          ctx: ctx,
          feat: feat,
          renderArgs: renderArgs,
          mismatchAlpha: mismatchAlpha,
          drawSNPsMuted: drawSNPsMuted,
          drawIndels: drawIndels,
          largeInsertionIndicatorScale: largeInsertionIndicatorScale,
          minSubfeatureWidth: minSubfeatureWidth,
          charWidth: charWidth,
          charHeight: charHeight,
          colorForBase: colorForBase,
          contrastForBase: contrastForBase,
          canvasWidth: canvasWidth
        });
        if (showSoftClip) {
          this.drawSoftClipping({
            ctx: ctx,
            feat: feat,
            renderArgs: renderArgs,
            config: config,
            theme: theme,
            canvasWidth: canvasWidth
          });
        }
      }
    } // we perform a full layout before render as a separate method because the
    // layout determines the height of the canvas that we use to render
  }, {
    key: "layoutFeats",
    value: function layoutFeats(props) {
      var _this2 = this;
      var layout = props.layout,
        features = props.features,
        sortedBy = props.sortedBy,
        config = props.config,
        bpPerPx = props.bpPerPx,
        showSoftClip = props.showSoftClip,
        regions = props.regions;
      var _regions4 = _slicedToArray(regions, 1),
        region = _regions4[0];
      if (!layout) {
        throw new Error("layout required");
      }
      if (!layout.addRect) {
        throw new Error('invalid layout object');
      }
      var featureMap = (sortedBy === null || sortedBy === void 0 ? void 0 : sortedBy.type) && region.start === sortedBy.pos ? sortFeature(features, sortedBy) : features;
      var heightPx = readConfObject(config, 'height');
      var displayMode = readConfObject(config, 'displayMode');
      return iterMap(featureMap.values(), function (feature) {
        return _this2.layoutFeature({
          feature: feature,
          layout: layout,
          bpPerPx: bpPerPx,
          region: region,
          showSoftClip: showSoftClip,
          heightPx: heightPx,
          displayMode: displayMode
        });
      }, featureMap.size);
    }
  }, {
    key: "fetchSequence",
    value: function () {
      var _fetchSequence2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(renderProps) {
        var sessionId, regions, adapterConfig, sequenceAdapter, _yield$getAdapter, dataAdapter, _regions5, region;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              sessionId = renderProps.sessionId, regions = renderProps.regions, adapterConfig = renderProps.adapterConfig;
              sequenceAdapter = adapterConfig.sequenceAdapter;
              if (sequenceAdapter) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", undefined);
            case 4:
              _context.next = 6;
              return getAdapter(this.pluginManager, sessionId, sequenceAdapter);
            case 6:
              _yield$getAdapter = _context.sent;
              dataAdapter = _yield$getAdapter.dataAdapter;
              _regions5 = _slicedToArray(regions, 1), region = _regions5[0];
              return _context.abrupt("return", _fetchSequence(region, dataAdapter));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchSequence(_x) {
        return _fetchSequence2.apply(this, arguments);
      }
      return fetchSequence;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(renderProps) {
        var _this3 = this;
        var _a, features, layout, regions, bpPerPx, _regions6, region, layoutRecords, regionSequence, end, start, width, height, Color, res, results;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getFeatures(renderProps);
            case 2:
              features = _context2.sent;
              layout = this.createLayoutInWorker(renderProps);
              regions = renderProps.regions, bpPerPx = renderProps.bpPerPx;
              _regions6 = _slicedToArray(regions, 1), region = _regions6[0];
              layoutRecords = this.layoutFeats(_objectSpread({}, renderProps, {
                features: features,
                layout: layout
              })); // only need reference sequence if there are features and only for some
              // cases
              if (!(features.size && shouldFetchReferenceSequence((_a = renderProps.colorBy) === null || _a === void 0 ? void 0 : _a.type))) {
                _context2.next = 13;
                break;
              }
              _context2.next = 10;
              return this.fetchSequence(renderProps);
            case 10:
              _context2.t0 = _context2.sent;
              _context2.next = 14;
              break;
            case 13:
              _context2.t0 = undefined;
            case 14:
              regionSequence = _context2.t0;
              end = region.end, start = region.start;
              width = (end - start) / bpPerPx;
              height = Math.max(layout.getTotalHeight(), 1);
              _context2.next = 20;
              return import('color').then(function (f) {
                return f.default;
              });
            case 20:
              Color = _context2.sent;
              _context2.next = 23;
              return renderToAbstractCanvas(width, height, renderProps, function (ctx) {
                return _this3.makeImageData({
                  ctx: ctx,
                  layoutRecords: layoutRecords,
                  canvasWidth: width,
                  renderArgs: _objectSpread({}, renderProps, {
                    layout: layout,
                    features: features,
                    regionSequence: regionSequence,
                    Color: Color
                  })
                });
              });
            case 23:
              res = _context2.sent;
              _context2.next = 26;
              return _get(_getPrototypeOf(PileupRenderer.prototype), "render", this).call(this, _objectSpread({}, renderProps, res, {
                features: features,
                layout: layout,
                height: height,
                width: width
              }));
            case 26:
              results = _context2.sent;
              return _context2.abrupt("return", _objectSpread({}, results, res, {
                features: new Map(),
                layout: layout,
                height: height,
                width: width,
                maxHeightReached: layout.maxHeightReached
              }));
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function render(_x2) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "createSession",
    value: function createSession(args) {
      return new PileupLayoutSession(args);
    }
  }]);
  return PileupRenderer;
}(BoxRendererType);
export { PileupRenderer as default };